import { render, staticRenderFns } from "./Aseguradoras.vue?vue&type=template&id=0c065b87&scoped=true&"
import script from "./Aseguradoras.vue?vue&type=script&lang=js&"
export * from "./Aseguradoras.vue?vue&type=script&lang=js&"
import style0 from "./Aseguradoras.vue?vue&type=style&index=0&id=0c065b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c065b87",
  null
  
)

export default component.exports